export default {
  // isPro: false,
  isPro: window.location.host.indexOf('casdt.cn') > -1,
  onoff: true,         //加密开关 是否前后端双向加密 备用 
  Base_Port: process.env.NODE_ENV == "development" ? "" : location.origin + "/",
  Base_url: process.env.NODE_ENV == "development" ? location.origin + "/" : location.origin + '/',
  key: "ABWE@@#aQWow!@#$",    //加密🔑
  Response: {
    success: 1,     //登录成功code
    overtime: 401,
    nopermission: 500    //登录超时code
  }
}
